import { ReactNode } from 'react';
import { Slide } from '@chakra-ui/react';
import { Button, Colors } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import { ReactComponent as RightChevron } from 'icons/double-right-shevron.svg';
import { useFlyoutNavigation } from 'state/flyoutNavigation';

const headerStyle = {
  justifyContent: 'space-between',
  gap: 'padding_8',
  alignItems: 'center',
  paddingTop: 'padding_16',
  paddingRight: 'padding_8',
  paddingLeft: 'padding_8',
  paddingBottom: 'padding_12',
};

const buttonStyle = {
  border: '2px solid',
  borderColor: Colors.ForestGreen900,
  backgroundColor: 'transparent',
  paddingY: 'padding_8',
  paddingX: 'padding_4',
  '&:hover': {
    border: '2px solid',
    borderColor: Colors.ForestGreen900,
    backgroundColor: 'transparent',
  },
};

type TFlyoutMenuProps = {
  children: ReactNode;
  mainAction?: ReactNode;
};

const FlyoutMenu = ({ mainAction, children }: TFlyoutMenuProps) => {
  const { flyoutNavigationOpen, updateFlyoutNavigationStatus } = useFlyoutNavigation();

  return (
    <Slide in={flyoutNavigationOpen} style={{ position: 'sticky' }} direction="left">
      {flyoutNavigationOpen && (
        <>
          <FlexRow sx={headerStyle}>
            <Button
              variant="functional"
              onClick={() => updateFlyoutNavigationStatus(!flyoutNavigationOpen)}
              sx={buttonStyle}
            >
              <RightChevron />
            </Button>
            {mainAction && mainAction}
          </FlexRow>
          {children}
        </>
      )}
    </Slide>
  );
};

export default FlyoutMenu;
